import React, { useState } from 'react';

const SelectedTasksContext = React.createContext();

function SelectedTasksProvider({ children }) {
  const [selected, setSelected] = useState([]);
  const [selectAllEnabled, setSelectAllEnabled] = useState({
    NOT_ATTENDED: false,
    KEEP_AN_EYE: false,
  });

  return (
    <SelectedTasksContext.Provider
      value={{ selected, setSelected, selectAllEnabled, setSelectAllEnabled }}
    >
      {children}
    </SelectedTasksContext.Provider>
  );
}

function useSelectedTasksContext() {
  const context = React.useContext(SelectedTasksContext);
  if (context === undefined) {
    throw new Error('useSelectedTasksContext must be used within a SelectedTasksProvider');
  }
  return context;
}

export { SelectedTasksProvider, useSelectedTasksContext };
